import React from 'react';
export default function useScrollTop(location) {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
}
